import { IIdObject } from '@common/interfaces/id-object.interface';
import { IReferralProgramObject } from '../registration-generated-api';

export interface IReferralProgramDto extends IIdObject, Omit<IReferralProgramObject, 'id'> {
    timeStamp: Date;
}

export const createReferralProgramDto = (item: IReferralProgramObject | undefined): IReferralProgramDto => {
    return {
        id: item?.id || '',
        ...item,
        timeStamp: new Date(Math.round((item?.timestamp || 1) * 1000)),
    };
};
